/**
 * Created by User on 03/03/2016.
 */
export default View;

function View(parentContainer) {
  var _parentContainer = parentContainer;
  var _currentContainer = null;

  this.createOverlayContainer = function(member) {
    var container = document.createElement('div');
    container.id = 'ad:overlay';
    var overlayDims = member.mediaFileDimensions;
    var width = 0,
      height = 0;
    try {
      width = parseInt(overlayDims.width);
      height = parseInt(overlayDims.height);
    } catch (error) {
      console.warn('Bad overlay\'s dimensions parsing in mggp-plugin-ad::View.createOverlayContainer');
    }
    if (width) {
      container.style.width = overlayDims.width + 'px';
    }
    if (height) {
      container.style.height = overlayDims.height + 'px';
    }

    _parentContainer.appendChild(container);
    _currentContainer = container;
    return container;
  };

  this.createIMAContainer = function() {
    _currentContainer = document.createElement('div');
    _currentContainer.id = 'ad:imaContainer';
    _currentContainer.style.width = '100%';
    _currentContainer.style.height = '100%';
    _parentContainer.appendChild(_currentContainer);
    return _currentContainer;
  };

  this.removeCurrentContainer = function() {
    if (_currentContainer && _currentContainer.parentNode) {
      _currentContainer.parentNode.removeChild(_currentContainer);
    }
  };

  Object.defineProperty(this, 'parentContainer', {
    enumerable: true,
    get: function() {
      return _parentContainer;
    }
  });
}
View.prototype.constructor = View;
